export const isMobile = () => $(window).width() < 768;
export const isTablet = () => $(window).width() >= 768 && $(window).width() <= 1023;
export const isDesktop = () => $(window).width() > 1023;
